import type { Route } from '@atlassian/react-resource-router';
import { rapidboardBacklogRouteEntry } from './rapidboardBacklogRouteEntry.tsx';
import { rapidboardBoardRouteEntry } from './rapidboardBoardRouteEntry.tsx';

export const classicSoftwareBoardSettingsInsightsRouteEntries: Route[] = [
	rapidboardBacklogRouteEntry,
	rapidboardBoardRouteEntry,
];
